import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  postStateRunning: {
    key: 'VideoStatusDescription-postStateRunning',
    defaultValue: 'Dados estão sendo atualizados (~1h de espera)',
  },
  postStateSuccess: {
    key: 'VideoStatusDescription-postStateSuccess',
    defaultValue: 'Última atualização: hoje',
  },
  postStateFailed: {
    key: 'VideoStatusDescription-postStateFailed',
    defaultValue: 'Atualização de dados falhou',
  },
  postUpdatedMoreThanTwoWeeksAgo: {
    key: 'VideoStatusDescription-postUpdatedMoreThanTwoWeeksAgo',
    defaultValue: 'Última atualização: >2sem',
  },
})
